import { z } from 'zod';
import { Validation } from '@mews/framework';
import { ConfigurationFieldName } from '../../../../../types';

export const configurationSchema = z.object({
    [ConfigurationFieldName.MaximumTime]: z
        .union([Validation.Number.MaxPositiveInteger, z.literal('')])
        .nullish()
        .transform((value) => (value === '' ? null : value)),
    [ConfigurationFieldName.Extent]: z.array(z.enum(['TimeUnits', 'Products', 'AdditionalExpenses'])).min(1),
    [ConfigurationFieldName.Options]: z
        .array(z.enum(['AutomaticDepositSettlement', 'CreateSettlementTask']))
        .nullish()
        .transform((value) => value ?? []),
});

export type ConfigurationFormValues = z.input<typeof configurationSchema>;
